import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import type { EditorView } from "@tiptap/pm/view";
import { normalizeQuotesInText, textHasTypographicQuotes } from "@repo/shared/quoteNormalize";

const pluginKey = new PluginKey("straightQuotes");

function insertNormalized(view: EditorView, from: number, to: number, text: string): boolean {
  const normalized = normalizeQuotesInText(text);
  if (normalized === text) return false;
  view.dispatch(view.state.tr.insertText(normalized, from, to).scrollIntoView());
  return true;
}

/** Keep typed/pasted quotes as ASCII " and ' so desktop (WKWebView smart quotes) matches web. */
export const StraightQuotes = Extension.create({
  name: "straightQuotes",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: pluginKey,
        props: {
          handleTextInput(view, from, to, text) {
            return insertNormalized(view, from, to, text);
          },
          transformPastedText(text) {
            return normalizeQuotesInText(text);
          },
          handleDOMEvents: {
            beforeinput(view, event) {
              if (!(event instanceof InputEvent)) return false;
              if (event.inputType !== "insertText" && event.inputType !== "insertReplacementText") {
                return false;
              }
              const data = event.data;
              if (!data || !textHasTypographicQuotes(data)) return false;
              event.preventDefault();
              let from = view.state.selection.from;
              let to = view.state.selection.to;
              const ranges = event.getTargetRanges?.() ?? [];
              if (ranges.length > 0) {
                try {
                  const r = ranges[0];
                  from = view.posAtDOM(r.startContainer, r.startOffset);
                  to = view.posAtDOM(r.endContainer, r.endOffset);
                } catch {
                  // Fall back to the current selection.
                }
              }
              view.dispatch(
                view.state.tr.insertText(normalizeQuotesInText(data), from, to).scrollIntoView()
              );
              return true;
            },
          },
        },
      }),
    ];
  },
});

export default StraightQuotes;
